import { createAction } from 'redux-actions';
export const receiveNotification = createAction('Notifications/NOTIFICATIONS_RECEIVED');
export const dismissNotification = createAction('Notifications/DISMISSED_NOTIFICATION');
export const dismissAllNotifications = createAction('Notifications/DISMISSED_ALL_NOTIFICATIONS');
